// extracted by mini-css-extract-plugin
export var avatar = "_qx-3";
export var avatarContainer = "_qx-2";
export var avatarSpacer = "_qx-5";
export var avatarSpacerContainer = "_qx-4";
export var avatarStackContainer = "_qx-1";
export var bubble = "_qx-0";
export var remainderBubble = "_qx-6";